// src/utils/lossRunLoad.js
//
// The one read path for the Loss Runs tab. Every load — first open and the
// Refresh button alike — re-reads all four sources of truth from SharePoint:
// FIG_LossRunSources, FIG_Policies, FIG_LossRunRequests and the insured's own
// FIG_Insureds row (which carries the LossRunAuth* columns). Nothing is cached
// here; figApi.getItems pages the whole list fresh on every call.

import { FIG_LISTS } from '../api/figApi';

export const LOSS_RUN_LISTS = [FIG_LISTS.LOSS_RUN_SOURCES, FIG_LISTS.POLICIES, FIG_LISTS.LOSS_RUN_REQUESTS, FIG_LISTS.INSUREDS];
export const LOSS_RUN_OPTIONAL_LISTS = [FIG_LISTS.LOSS_RUN_RESOLUTIONS];

/**
 * loadLossRunData({ getItems, token, insuredId })
 * → { sources, policies, requests, insured, resolutions, warnings }
 *   policies/requests/resolutions filtered to the insured; insured is the
 *   fresh FIG_Insureds row or null if not found. FIG_LossRunResolutions is
 *   optional: until it is provisioned live its read fails, which yields []
 *   plus a warning instead of failing the whole tab.
 */
export async function loadLossRunData({ getItems, token, insuredId }) {
  const iid = String(insuredId);
  const [sources, policies, requests, insureds] = await Promise.all(
    LOSS_RUN_LISTS.map(list => getItems(token, list)),
  );
  const warnings = [];
  let resolutions = [];
  try {
    resolutions = (await getItems(token, FIG_LISTS.LOSS_RUN_RESOLUTIONS)) || [];
  } catch (err) {
    warnings.push(`${FIG_LISTS.LOSS_RUN_RESOLUTIONS} not available: ${err?.message || err}`);
  }
  return {
    sources: sources || [],
    policies: (policies || []).filter(p => String(p.InsuredId) === iid),
    requests: (requests || []).filter(r => String(r.InsuredId) === iid),
    resolutions: resolutions.filter(r => String(r.InsuredId) === iid),
    insured: (insureds || []).find(r => String(r.id) === iid) || null,
    warnings,
  };
}
